import { useParams, useLocation, useNavigate } from 'react-router-dom';

export const withRouter = (Component) => {
  return (props) => {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    return (
      <Component
        {...props}
        router={{ params, location, navigate }}
        navigate={navigate}
        location={location}
        params={params}
      />
    );
  };
};